<div class="sidebar-cart d-flex flex-direction-column gap-20 h-0 flex-grow-1" [class.sidebar-cart--customer-screen]="isCustomerScreen">
  <app-content-box theme="gray" class="flex-grow-1">
    <div class="d-flex align-items-center gap-8 justify-content-space-between">
      <h4 class="text-uppercase">
        {{ 'Cart'| trans:'cart/sidebar/title.Text' }}
      </h4>

      @if (!isCustomerScreen) {
        <button
          #btn
          class="button button--sm button--strong-ghost"
          (click)="clearCart(btn)"
          [disabled]="!cartStore.cart() || cartStore.cart().status === cartStatuses.CheckedOut || cartStore.cart().items.length === 0 || isPreviewMode"
        >
          <i class="ri-delete-bin-line"></i>
          {{ 'Cancel'| trans:'cart/sidebar/cancel.Button' }}
        </button>
      }
    </div>

    <div class="separator" [class.m-t-8]="isCustomerScreen" [class.m-b-12]="isCustomerScreen"></div>

    <div class="flex-grow-1 d-flex flex-direction-column">
      <app-scrollable-wrapper>
        @if (isCartLoading()) {
          <div class="d-flex justify-content-center">
            <app-loader size="md" />
          </div>
        } @else if (cartStore.cart()) {
          @if (cartStore.cart().items.length === 0) {
            <p>{{ 'Cart is empty.'| trans:'cart/sidebar/empty.Text' }}</p>
          } @else {
            @if (cartStore.groupedCartItemsTickets().length > 0) {
              <div class="group">
                <div class="d-flex flex-direction-column gap-16">
                  @for (item of cartStore.groupedCartItemsTickets(); track item.showId + '_' + item.showBegin + '_' + item.auditoriumName + '_' + item.cinemaName) {
                    @if (!isPaySeparatelyModeEnabled() || hasSelectedTicketsInGroup(item)) {
                      <ng-container [ngTemplateOutlet]="cartItemTicket" [ngTemplateOutletContext]="{ item }" />
                    }
                  }
                </div>
              </div>
            }

            @if (cartStore.cartItemsProductsAndPackages().length > 0) {
              <div class="group">
                <div class="d-flex flex-direction-column gap-8">
                  @for (item of cartStore.cartItemsProductsAndPackages(); track item.itemId + '_' + item.position) {
                    <ng-container [ngTemplateOutlet]="cartItemProduct" [ngTemplateOutletContext]="{ item }" />
                  }
                </div>
              </div>
            }

            @if (cartStore.cartItemsVouchers().length > 0) {
              <div class="group">
                <div class="d-flex flex-direction-column gap-8">
                  @for (item of cartStore.cartItemsVouchers(); track item.itemId + '_' + item.position) {
                    <ng-container [ngTemplateOutlet]="cartItemVoucher" [ngTemplateOutletContext]="{ item }" />
                  }
                </div>
              </div>
            }

            @if (cartStore.cartItemsCashedVouchers().length > 0) {
              <div class="group">
                <div class="d-flex flex-direction-column gap-8">
                  @for (item of cartStore.cartItemsCashedVouchers(); track item.itemId + '_' + item.position) {
                    <ng-container [ngTemplateOutlet]="cartItemVoucher" [ngTemplateOutletContext]="{ item }" />
                  }
                </div>
              </div>
            }

            @if (cartStore.cartItemsCards().length > 0) {
              <div class="group">
                <div class="d-flex flex-direction-column gap-8">
                  @for (item of cartStore.cartItemsCards(); track item.itemId + '_' + item.position) {
                    <ng-container [ngTemplateOutlet]="cartItemCard" [ngTemplateOutletContext]="{ item }" />
                  }
                </div>
              </div>
            }

            @if (cartStore.cartItemsCancelledTickets().length > 0) {
              <div class="group">
                <div class="d-flex flex-direction-column gap-8">
                  @for (item of cartStore.cartItemsCancelledTickets(); track item.itemId + '_' + item.position) {
                    <ng-container [ngTemplateOutlet]="cartItemCancelTicketOrGood" [ngTemplateOutletContext]="{ item }" />
                  }
                </div>
              </div>
            }

            @if (cartStore.cartItemsCancelledGoods().length > 0) {
              <div class="group">
                <div class="d-flex flex-direction-column gap-8">
                  @for (item of cartStore.cartItemsCancelledGoods(); track item.itemId + '_' + item.position) {
                    <ng-container [ngTemplateOutlet]="cartItemCancelTicketOrGood" [ngTemplateOutletContext]="{ item }" />
                  }
                </div>
              </div>
            }

            @if (cartStore.cartItemsCancelledVouchers().length > 0) {
              <div class="group">
                <div class="d-flex flex-direction-column gap-8">
                  @for (item of cartStore.cartItemsCancelledVouchers(); track item.itemId + '_' + item.position) {
                    <ng-container [ngTemplateOutlet]="cartItemCancelTicketOrGood" [ngTemplateOutletContext]="{ item }" />
                  }
                </div>
              </div>
            }

          }
        }
      </app-scrollable-wrapper>
    </div>
  </app-content-box>

  @if (isCartLoading()) {
    <div class="d-flex justify-content-center">
      <app-loader size="md" />
    </div>
  } @else if (cartStore.cart()) {
    @if (!isCustomerScreen) {
      @if (cartStore.customerCards().length > 0) {
        <app-content-box theme="gray" class="m-b-8">
          <div class="d-flex flex-direction-column gap-8">
            @for (card of cartStore.customerCards(); track card.cardId) {
              <div class="card-item d-flex align-items-center gap-8">
                <i class="ri-bank-card-line"></i>
                <div
                  class="d-flex flex-direction-column flex-grow-1 cursor-pointer"
                  (click)="cardDetailsModalComponent.open({ card })"
                >
                  <span class="fw-semibold">
                    Nr. {{ card.cardNr }}
                  </span>
                  @if (isAuthorizeOnlyCard(card.cardTypeId)) {
                    <span class="p3 c-t-gray-700">
                      {{ 'Authorize only' | trans:'cart/sidebar-cart/authorizeOnly.Label' }}
                    </span>
                  } @else {
                    <span class="p3 c-t-gray-600">
                      {{ 'aktuell verfügbar:' | trans:'cart/sidebar-cart/currentlyAvailable.Label' }} {{ card.currentBalance | numberToCurrency }}{{ languageConfig.currency.short }}
                    </span>
                    <span class="p3">
                      - {{ (cardPaymentAmounts().get(card.cardId) ?? 0) | numberToCurrency }}{{ languageConfig.currency.short }}
                    </span>
                  }
                </div>
                <button
                  class="button button--icon-xs button--no-border c-t-blue-500"
                  (click)="cardDetailsModalComponent.open({ card }); $event.stopPropagation()"
                  appTooltip
                  [delay]="tooltipDelay"
                  content="{{ 'Card details' | trans:'cart/sidebar/card-details.Tooltip' }}"
                >
                  <i class="ri-information-line"></i>
                </button>
                <button
                  class="button button--icon-xs button--no-border c-t-nok-400"
                  (click)="detachCard(card.cardId); $event.stopPropagation()"
                  [disabled]="isPreviewMode"
                  appTooltip
                  [delay]="tooltipDelay"
                  content="{{ 'Detach card' | trans:'cart/sidebar/detach-card.Tooltip' }}"
                >
                  <i class="ri-delete-bin-line"></i>
                </button>
              </div>
            }
          </div>
        </app-content-box>
      }

      @if (appliedDiscountCode(); as discountCode) {
        <app-content-box theme="gray" class="m-b-8">
          <div class="d-flex align-items-center justify-content-space-between gap-8">
            <div class="d-flex align-items-center gap-8 flex-grow-1">
              <i class="ri-discount-percent-line"></i>
              <div class="d-flex flex-direction-column flex-grow-1">
                <span class="fw-semibold">{{ discountCode.code }}</span>
                <span class="p3 c-t-gray-600">
                  -{{ discountCode.amount | numberToCurrency }} {{ languageConfig.currency.short }}
                </span>
              </div>
            </div>
            <button
              class="button button--icon-xs button--no-border c-t-nok-400"
              (click)="removeDiscountFromCart()"
              [disabled]="isPreviewMode"
              appTooltip
              [delay]="tooltipDelay"
              content="{{ 'Remove discount' | trans:'cart/sidebar/remove-discount.Tooltip' }}"
            >
              <i class="ri-close-line"></i>
            </button>
          </div>
        </app-content-box>
      }

      <div class="d-flex full-width gap-8">
        <div class="flex-1 position-relative">
          <button
            class="button button--quick-action button--quick-action--blue full-width"
            (click)="voucherCodeInputModalComponent.open()"
            appTooltip
            [delay]="tooltipDelay"
            content="{{ 'Internal vouchers' | trans:'cart/sidebar/internal-vouchers.Tooltip' }}"
            [disabled]="isReservationTerminal || isPreviewMode"
          >
            <i class="ri-gift-2-line"></i>
          </button>
        </div>

        <div class="flex-1 position-relative">
          <button
            class="button button--quick-action button--quick-action--blue full-width"
            (click)="externalVouchersModalComponent.open()"
            [disabled]="isReservationTerminal || isPreviewMode || !hasExternalVoucherTypes"
            appTooltip
            [delay]="tooltipDelay"
            content="{{ 'Partner vouchers' | trans:'cart/sidebar/partner-vouchers.Tooltip' }}"
          >
            <i class="ri-shake-hands-line"></i>
          </button>
        </div>

        <div class="flex-1">
          <button
            class="button button--quick-action button--quick-action--blue full-width"
            (click)="cardCodeInputModalComponent.open(null, 'add-payment-method')"
            [disabled]="isReservationTerminal"
            appTooltip
            [delay]="tooltipDelay"
            content="{{ 'CineCards' | trans:'cart/sidebar/cinecards.Tooltip' }}"
          >
            <i class="ri-heart-line"></i>
          </button>
        </div>

        <div class="flex-1">
          <button
            class="button button--quick-action button--quick-action--blue full-width"
            (click)="discountModalComponent.open()"
            [disabled]="(cartStore.cart().items.length === 0 && !cartStore.cart().discount) || isReservationTerminal || isPreviewMode"
            appTooltip
            [delay]="tooltipDelay"
            content="{{ 'Discounts' | trans:'cart/sidebar/discounts.Tooltip' }}"
          >
            @if (cartStore.cart().discount) {
              <span
                #btnDiscount
                class="button button--icon-sm button--primary-ghost"
                (click)="$event.stopPropagation(); clearCartAndDetachCard()"
                role="button"
                appTooltip
                [delay]="tooltipDelay"
                content="{{ 'Remove discount' | trans:'cart/sidebar/remove-discount.Tooltip' }}"
              >
                <i class="ri-close-line"></i>
              </span>
            }

            <i class="ri-percent-line"></i>
          </button>
        </div>

        <div class="flex-1">
          <button
            class="button button--quick-action button--quick-action--blue full-width"
            (click)="openPaySeparatelyModal()"
            [disabled]="!(!isReservationTerminal && cartStore.cart().status === cartStatuses.Pending && isPartialPaymentPossible)"
            appTooltip
            [delay]="tooltipDelay"
            content="{{ 'Split payment' | trans:'cart/sidebar/split-payment.Tooltip' }}"
          >
            <i class="ri-arrow-left-right-line"></i>
          </button>
        </div>
      </div>

      <div class="separator m-y-0"></div>

      <div class="d-flex align-items-center justify-content-flex-end p-x-8">
        <div class="fw-medium t4 c-t-gray-600 m-l-auto m-r-auto text-uppercase">{{ 'IN total'| trans:'cart/sidebar/in-total.Text' }}</div>
        <div class="fw-medium t4">
          {{ (isPaySeparatelyModeEnabled() ? selectedItemsTotal() : cartStore.cart().totalPrice) | numberToCurrency }} {{ languageConfig.currency.short }}
        </div>
      </div>

      <div class="d-flex flex-direction-column gap-8">
        <button
          class="button button--lg button--primary text-uppercase full-width"
          (click)="openSummaryModal()"
          [disabled]="areSummaryButtonsDisabled"
        >
          {{ 'summary'| trans:'cart/sidebar/summary.Button' }}
        </button>

        <div class="quick-actions d-flex gap-8">
          <button
            class="button button--quick-action button--quick-action--blue aspect-ratio-1 flex-grow-1"
            (click)="processQuickCashPayment()"
            [disabled]="areSummaryButtonsDisabled || cartStore.cart().totalPrice <= 0 || isTerminalWithoutSafe || (terminalsStore.arePaymentMethodsRestricted() && !terminalsStore.allowedPaymentMethodsMap()[cartPaymentMethods.Cash])"
            appTooltip
            [delay]="tooltipDelay"
            content="{{ 'Quick cash payment' | trans:'cart/sidebar/quick-cash-payment.Tooltip' }}"
          >
            <i class="ri-cash-line"></i>
          </button>

          <button
            class="button button--quick-action button--quick-action--blue aspect-ratio-1 flex-grow-1"
            (click)="processQuickCardPayment()"
            [disabled]="areSummaryButtonsDisabled || isReservationTerminal || cartStore.cart().paidAmount >= paySeparatelyStore.toPayAmount() || (!terminalParametersMap()[terminalParameterKeys.CASH_EC_TERMINAL_IP] && !isEcStandalone) || (terminalsStore.arePaymentMethodsRestricted() && !terminalsStore.allowedPaymentMethodsMap()[cartPaymentMethods.Card])"
            appTooltip
            [delay]="tooltipDelay"
            content="{{ 'Quick card payment' | trans:'cart/sidebar/quick-card-payment.Tooltip' }}"
          >
            <i class="ri-bank-card-2-line"></i>
          </button>

          <button
            class="button button--quick-action button--quick-action--blue aspect-ratio-1 flex-grow-1"
            (click)="processQuickInvoicePayment()"
            [disabled]="areSummaryButtonsDisabled || cartStore.cart().totalPrice <= 0 || (terminalsStore.arePaymentMethodsRestricted() && !terminalsStore.allowedPaymentMethodsMap()[cartPaymentMethods.Invoice])"
            appTooltip
            [delay]="tooltipDelay"
            content="{{ 'Quick invoice payment' | trans:'cart/sidebar/quick-invoice-payment.Tooltip' }}"
          >
            <i class="ri-bill-line"></i>
          </button>
        </div>
      </div>
    } @else {
      <div class="d-flex align-items-center justify-content-flex-end p-x-8">
        <div class="fw-medium t4 c-t-gray-600 m-l-auto m-r-16 text-uppercase">{{ 'IN total'| trans:'cart/sidebar/in-total.Text' }}</div>

        <button
          class="button button--lg button--primary text-uppercase pointer-events-none t1 p-x-40 fw-regular"
        >
          {{ (isPaySeparatelyModeEnabled() ? selectedItemsTotal() : cartStore.cart().totalPrice) | numberToCurrency }} {{ languageConfig.currency.short }}
        </button>
      </div>
    }
  }
</div>

<ng-template #cartItemTicket let-item="item">
  <div class="cart-item">
    <button
      (click)="openShow(item.showId, item.cinemaId)"
      class="p1 fw-semibold text-decoration-underline c-t-blue-700"
      [class.text-decoration-underline]="!isCustomerScreen"
    >{{ item.showTitle }}</button>
    <div class="p2">
      {{ item.showBegin | localeDatetimeFormat }};
      @if (cartStore.showTicketCinemaName()) {
        <br><i>{{ item.cinemaName }} / {{ item.auditoriumName }}</i>
      } @else {
        <i>{{ item.auditoriumName }}</i>
      }
    </div>
    <div class="m-t-8 d-flex flex-direction-column gap-8 tickets">
      @for (ticket of item.tickets; track ticket.itemId + '_' + ticket.position) {
        @if (!isPaySeparatelyModeEnabled() || !paySeparatelyStore.isHidden(ticket.itemId, ticket.position)) {
          <app-content-box theme="white" borderRadius="base-border-radius" padding="p-l-8 p-b-8 p-t-4 p-r-4">
            <div class="d-flex align-items-center justify-content-space-between gap-8">
              <div class="d-flex align-items-center gap-24">
                <div class="d-flex align-items-center gap-12 p2">
                  <div>{{ 'Row'| trans:'cart/ticket/row.Label' }}</div>
                  <div class="fw-semibold">{{ ticket.seatRow }}</div>
                </div>
                <div class="d-flex align-items-center gap-12 p2">
                  <div>
                    {{ 'Seat'| trans:'cart/ticket/seat.Label' }}
                  </div>
                  <div class="fw-semibold">{{ ticket.seatNr }}</div>
                </div>
              </div>
              @if (cartStore.cart().status === cartStatuses.Pending && !isCustomerScreen) {
                <div class="d-flex align-items-center gap-12">
                  <button
                    #btn1
                    class="button button--icon-xs button--no-border c-t-nok-400"
                    (click)="removeItemFromCart(ticket.itemId, ticket.position, btn1)"
                    appTooltip
                    [delay]="tooltipDelay"
                    content="{{ 'Remove ticket' | trans:'cart/ticket/remove.Tooltip' }}"
                  >
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </div>
              }
            </div>

            <div class="m-t-4 d-flex flex-direction-column gap-4 p-r-4">
              @if (!isCustomerScreen && cartStore.cart().status === cartStatuses.Pending && (ticket.partnerCode || ticket.voucherNumber)) {
                <div class="p3 c-t-gray-600">
                  {{ ticket.partnerCode || ticket.voucherNumber }}
                </div>
              }
              <div class="d-flex align-items-center justify-content-space-between gap-8">
                <div class="w-0 flex-grow-1">
                  @if (!isCustomerScreen) {
                    @if (cartStore.cart().status === cartStatuses.Pending) {
                      <app-chip
                        [withIcon]="false"
                        [value]="ticket.priceCategoryId"
                        [label]="ticket.priceCategoryToken || ticket.priceCategory"
                        [selected]="true"
                        [disabled]="isPreviewMode"
                        [suffixIcon]="missingCardPriceCategoryIds().has(ticket.priceCategoryId) ? 'ri-bank-card-line' : undefined"
                        [suffixIconClass]="''"
                        (click)="isReservationTerminal ? null : priceCategoryPickerModalComponent.open({ ticket })"
                      />
                    } @else {
                      {{ ticket.priceCategoryToken || ticket.priceCategory }}
                    }
                  } @else {
                    <div class="d-flex align-items-center gap-12 p2">
                      <div>
                        {{ 'Type'| trans:'cart/ticket/type.Label' }}
                      </div>
                      <div class="fw-semibold">{{ ticket.priceCategoryToken || ticket.priceCategory }}</div>
                    </div>
                  }
                </div>
                <div class="{{ isCustomerScreen ? 'p1' : 'p2' }} price text-right d-flex align-items-center gap-4 justify-content-flex-end flex-shrink-0">
                  {{ ticket | cartItemDisplayTotal: cartStore.cart().discount: cartStore.cart().items | numberToCurrency }} {{ languageConfig.currency.short }}
                </div>
              </div>
            </div>
          </app-content-box>
        }
      }
    </div>
  </div>
</ng-template>

<ng-template #cartItemProduct let-item="item">
  @if (!isPaySeparatelyModeEnabled() || getPositionQuantity(item.itemId, item.position) > 0) {
    <div class="cart-item">
      <div class="d-flex flex-direction-column gap-8">
        <app-content-box theme="white" borderRadius="base-border-radius" padding="p-l-8 p-b-8 p-t-4 p-r-4">
        <div class="d-flex align-items-center justify-content-space-between gap-8">
          <div>{{ item.name }}</div>
          @if (cartStore.cart().status === cartStatuses.Pending && !isCustomerScreen) {
            <button
              #btn2
              class="button button--icon-xs button--no-border c-t-nok-400"
              (click)="removeItemFromCart(item.itemId, item.position, btn2)"
              appTooltip
              [delay]="tooltipDelay"
              content="{{ 'Remove item' | trans:'cart/item/remove.Tooltip' }}"
            >
              <i class="ri-delete-bin-line"></i>
            </button>
          }
        </div>

        @if (item.itemType === cartItemTypes.Package) {
          <div class="d-flex justify-content-space-between gap-8 m-t-4 m-b-12">
            <div class="p3 c-t-gray-600">
              @for (product of item.packageProducts; track product.id; let last = $last) {
                {{ product.name }}
                @if (!last) {
                  <br>
                }
              }
            </div>

            @if (item.flagPackageEditable && cartStore.cart().status === cartStatuses.Pending && !isCustomerScreen) {
              <button
                class="button button--icon-xs button--no-border c-t-blue-500"
                (click)="openPackageProductsSelectionModal(item)"
                appTooltip
                [delay]="tooltipDelay"
                content="{{ 'Edit package' | trans:'cart/item/edit-package.Tooltip' }}"
              >
                <i class="ri-pencil-line"></i>
              </button>
            }
          </div>
        }

          <div class="m-t-4 d-flex align-items-center justify-content-space-between p-r-4 gap-8">
            @let quantity = !isPaySeparatelyModeEnabled() ? item.quantity : (getPositionQuantity(item.itemId, item.position));

            @if (item.itemType === cartItemTypes.Product || (item.itemType === cartItemTypes.Package && item.packageProducts.length === 0)) {
              <div class="w-0 flex-grow-1">
                @if (!isCustomerScreen) {
                  @if (cartStore.cart().status === cartStatuses.Pending) {
                    <app-stepper
                      [maxValue]="10000"
                      [ngModel]="quantity"
                      (ngModelChange)="updateCartItem$.next({ item, quantity: $event })"
                    />
                  } @else {
                    x {{ quantity }}
                  }
                } @else {
                  <div class="d-flex align-items-center gap-12 p2">
                    <div>
                      {{ 'Quantity'| trans:'cart/item/quantity.Label' }}
                    </div>
                    <div class="fw-semibold">{{ quantity }}</div>
                  </div>
                }
              </div>
            }

            <div class="m-t-4 d-flex align-items-center justify-content-flex-end p-r-4 to-right">
              <div
                class="{{ isCustomerScreen ? 'p1' : 'p2' }} price text-right"
              >{{ (isPaySeparatelyModeEnabled() ? (item.price * quantity) : item.totalPrice) | numberToCurrency }} {{ languageConfig.currency.short }}</div>
            </div>
          </div>
        </app-content-box>
      </div>
    </div>
  }
</ng-template>

<ng-template #cartItemVoucher let-item="item">
  @if (!isPaySeparatelyModeEnabled() || getPositionQuantity(item.itemId, item.position) > 0) {
    <div class="cart-item">
    <div class="d-flex flex-direction-column gap-8">
      <app-content-box theme="white" borderRadius="base-border-radius" padding="p-l-8 p-b-8 p-t-4 p-r-4">
        <div class="d-flex align-items-center justify-content-space-between gap-8">
          <div>{{ item.name }}</div>
          @if (cartStore.cart().status === cartStatuses.Pending && !isCustomerScreen) {
            <button
              #btn3
              class="button button--icon-xs button--no-border c-t-nok-400"
              (click)="removeItemFromCart(item.itemId, item.position, btn3)"
              appTooltip
              [delay]="tooltipDelay"
              content="{{ 'Remove voucher' | trans:'cart/voucher/remove.Tooltip' }}"
            >
              <i class="ri-delete-bin-line"></i>
            </button>
          }
        </div>

          @if (item | isVoucherStackable) {
            @let quantity = !isPaySeparatelyModeEnabled() ? item.quantity : (getPositionQuantity(item.itemId, item.position));
            <div class="m-t-4 d-flex align-items-center justify-content-space-between p-r-4 gap-8">
              <div class="w-0 flex-grow-1">
                @if (!isCustomerScreen) {
                  @if (cartStore.cart().status === cartStatuses.Pending) {
                    <app-stepper
                      [maxValue]="10000"
                      [ngModel]="quantity"
                      (ngModelChange)="updateCartItem$.next({ item, quantity: $event })"
                    />
                  } @else {
                    x {{ quantity }}
                  }
                } @else {
                  <div class="d-flex align-items-center gap-12 p2">
                    <div>
                      {{ 'Quantity'| trans:'cart/item/quantity.Label' }}
                    </div>
                    <div class="fw-semibold">{{ quantity }}</div>
                  </div>
                }
              </div>
              <div class="m-t-4 d-flex align-items-center justify-content-flex-end p-r-4 to-right">
                <div
                  class="{{ isCustomerScreen ? 'p1' : 'p2' }} price text-right"
                >{{ (isCustomerScreen || isPaySeparatelyModeEnabled() ? (item.price * quantity) : item.totalPrice) | numberToCurrency }} {{ languageConfig.currency.short }}</div>
              </div>
            </div>
          } @else {
            <div class="m-t-4 d-flex align-items-center justify-content-flex-end p-r-4">
              <div
                class="{{ isCustomerScreen ? 'p1' : 'p2' }} price text-right"
              >{{ item.totalPrice | numberToCurrency }} {{ languageConfig.currency.short }}</div>
            </div>
          }
        </app-content-box>
      </div>
    </div>
  }
</ng-template>

<ng-template #cartItemCancelTicketOrGood let-item="item">
  @if (!isPaySeparatelyModeEnabled() || !paySeparatelyStore.isHidden(item.itemId, item.position)) {
    <div class="cart-item">
    <div class="d-flex flex-direction-column gap-8">
      <app-content-box theme="white" borderRadius="base-border-radius" padding="p-l-8 p-b-8 p-t-4 p-r-4">
        <div class="d-flex align-items-center justify-content-space-between gap-8">
          <div>{{ item.name }}</div>
          @if (cartStore.cart().status === cartStatuses.Pending && !isCustomerScreen) {
            <button
              #btn4
              class="button button--icon-xs button--no-border c-t-nok-400"
              (click)="removeItemFromCart(item.itemId, item.position, btn4)"
              appTooltip
              [delay]="tooltipDelay"
              content="{{ 'Remove item' | trans:'cart/item/remove.Tooltip' }}"
            >
              <i class="ri-delete-bin-line"></i>
            </button>
          }
        </div>

          <div class="m-t-4 d-flex align-items-center justify-content-flex-end p-r-4">
            <div
              class="{{ isCustomerScreen ? 'p1' : 'p2' }} price text-right"
            >{{ item.totalPrice | numberToCurrency }} {{ languageConfig.currency.short }}</div>
          </div>
        </app-content-box>
      </div>
    </div>
  }
</ng-template>

<ng-template #cartItemCard let-item="item">
  @if (!isPaySeparatelyModeEnabled() || !paySeparatelyStore.isHidden(item.itemId, item.position)) {
    <div class="cart-item">
    <div class="d-flex flex-direction-column gap-8">
      <app-content-box theme="white" borderRadius="base-border-radius" padding="p-l-8 p-b-8 p-t-4 p-r-4">
        <div class="d-flex align-items-center justify-content-space-between gap-8">
          <div>{{ item.name }}</div>
          @if (cartStore.cart().status === cartStatuses.Pending && !isCustomerScreen) {
            <button
              #btn5
              class="button button--icon-xs button--no-border c-t-nok-400"
              (click)="removeItemFromCart(item.itemId, item.position, btn5)"
              appTooltip
              [delay]="tooltipDelay"
              content="{{ 'Remove card' | trans:'cart/card/remove.Tooltip' }}"
            >
              <i class="ri-delete-bin-line"></i>
            </button>
          }
        </div>

          <div class="m-t-4 d-flex align-items-center justify-content-flex-end p-r-4">
            <div
              class="{{ isCustomerScreen ? 'p1' : 'p2' }} price text-right"
            >{{ item.totalPrice | numberToCurrency }} {{ languageConfig.currency.short }}</div>
          </div>
        </app-content-box>
      </div>
    </div>
  }
</ng-template>

<ng-template #cartItemCardPayment let-item="item">
  @if (!isPaySeparatelyModeEnabled() || !paySeparatelyStore.isHidden(item.itemId, item.position)) {
    <div class="cart-item">
    <div class="d-flex flex-direction-column gap-8">
      <app-content-box theme="white" borderRadius="base-border-radius" padding="p-l-8 p-b-8 p-t-4 p-r-4">
        <div class="d-flex align-items-center justify-content-space-between gap-8">
          <div>{{ item.name }}</div>
          @if (cartStore.cart().status === cartStatuses.Pending && !isCustomerScreen) {
            <button
              #btn6
              class="button button--icon-xs button--no-border c-t-nok-400"
              (click)="removeItemFromCart(item.itemId, item.position, btn6)"
              appTooltip
              [delay]="tooltipDelay"
              content="{{ 'Remove item' | trans:'cart/item/remove.Tooltip' }}"
            >
              <i class="ri-delete-bin-line"></i>
            </button>
          }
        </div>

          <div class="m-t-4 d-flex align-items-center justify-content-flex-end p-r-4">
            <div
              class="{{ isCustomerScreen ? 'p1' : 'p2' }} price text-right"
            >{{ item.totalPrice | numberToCurrency }} {{ languageConfig.currency.short }}</div>
          </div>
        </app-content-box>
      </div>
    </div>
  }
</ng-template>

<app-summary-modal #summaryModalComponent />
<app-package-products-selection-modal #packageProductsSelectionModal />
<app-price-category-picker-modal #priceCategoryPickerModalComponent />
<app-voucher-code-input-modal #voucherCodeInputModalComponent />
<app-external-vouchers-modal #externalVouchersModalComponent />
<app-card-code-input-modal
  #cardCodeInputModalComponent
  (codeSubmitted)="cardDetailsModalComponent.open({ card: cartStore.customerCards()[0] })"
  (cardPaymentDialogRequired)="cardPaymentBalanceInfoModalComponent.open($event)"
  (voucherDetailsRequested)="onVoucherDetailsFromCardAttach($event)"
/>
<app-card-amount-picker-modal
  #cardAmountPickerModalComponent
/>
<app-card-details-modal #cardDetailsModalComponent />
<app-voucher-details-modal #voucherDetailsModalComponent></app-voucher-details-modal>
<app-discounts-modal #discountModalComponent />
<app-pay-separately-selection-modal
  #paySeparatelySelectionModalComponent
/>
<app-card-payment-balance-info-modal
  #cardPaymentBalanceInfoModalComponent
  (openCardAmountPicker)="cardAmountPickerModalComponent.open($event.cardType, $event.card, $event.loadAmountOffset)"
/>

<app-voucher-details-modal #voucherDetailsModalComponent></app-voucher-details-modal>
